import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Shield, Sparkles, GraduationCap, BadgeDollarSign, CheckCircle2 } from "lucide-react";
import Section1 from "../Page1Main/Sections/Section1copy";
import NowVsFutureSection from "../Phone/NowVsFutureSection";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import GildarcLearnHome from "./GildarcLearnHome";

// Simple mockup customer-facing landing page
export default function GildarcCustomerLanding() {
 const { t } = useTranslation();
 const navigate = useNavigate();

const start = () => {
  navigate("/modules"); // change to your target page
   window.scrollTo(0, 0);
};


  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* Hero */}
     <section className="mx-auto max-w-5xl px-6 py-24 text-center">
  <motion.h1
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    className="text-5xl font-bold mb-6 text-slate-900"
   >
    Money
  <br />
    <br />
{t("h1")} 
  </motion.h1>

  <p className="text-2xl font-medium text-slate-900 mb-2">
    {t("h2")} {/* Example: You work hard. */}
  </p>

  <p className="max-w-2xl mx-auto text-lg text-slate-700 mb-2">
    {t("h3")} {/* Hidden benefits behind rules you don’t understand. */}
  </p>

  <p className="max-w-2xl mx-auto text-lg text-slate-700 mb-6">
    {t("h4")} {/* Millions miss money every year without knowing it. */}
  </p>

  <a
    href="/modules"
    className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-6 py-3 text-white text-lg shadow-lg hover:bg-slate-800 transition"
  >
   {t("mid12")}  <ArrowRight className="w-5 h-5" />
  </a>
</section>


      {/* Value Props */}
      <section className="bg-white py-20" style={{marginBottom: "-50px", marginTop:""}}>
        
          {t("mp1").toUpperCase()}

   
      </section>

    

<GildarcLearnHome />

      {/* CTA */}
      <section className="text-center py-20 bg-slate-900 text-white" style={{borderRadius: "0px"}}>
        <h2 className="text-4xl font-bold mb-6">    {t("try1")}</h2>
        <p className="max-w-xl mx-auto text-lg mb-10">
        {t("try2")}
        </p>
        <button className="rounded-xl bg-white text-slate-900 px-8 py-3 text-lg shadow-lg flex items-center gap-2 mx-auto"  onClick={start}>
         {t("try3")}<ArrowRight className="w-5 h-5" />
        </button>
      </section>
      
    </div>
  );
}
